import { render, staticRenderFns } from "./SelectableAddOnOptionGroupsList.vue?vue&type=template&id=a1bef1d8"
import script from "./SelectableAddOnOptionGroupsList.vue?vue&type=script&lang=ts"
export * from "./SelectableAddOnOptionGroupsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports